import type { AuthUser } from './auth-context.js';

export function isRestrictedStaff(user: AuthUser | null): boolean {
  if (!user) return false;
  const admin = user.roles.some((r) => r.role === 'ADMIN');
  if (!admin && !user.roles.some((r) => r.role === 'OPERATOR')) return false;
  return (
    !(admin && user.ownerAdmin === true) &&
    (user.staffRestricted === true || (admin && user.ownerAdmin === false))
  );
}

export function staffRouteAllowed(user: AuthUser | null, path: string): boolean {
  if (path === '/admin/staff-access')
    return user?.ownerAdmin === true && user.roles.some((r) => r.role === 'ADMIN');
  if (!isRestrictedStaff(user)) return true;
  return !(
    ['/reports', '/customers/new', '/partners/new'].includes(path) ||
    (path.startsWith('/admin/') && path !== '/admin/rbac')
  );
}

export function canWriteStaffScope(
  user: AuthUser | null,
  scopeType: string,
  scopeId: string,
): boolean {
  return (
    !isRestrictedStaff(user) ||
    Boolean(
      user?.staffScopes?.some(
        (s) => s.scopeType === scopeType && s.scopeId === scopeId && s.canWrite,
      ),
    )
  );
}
